<template>
  <div class="offer-box">
    <div>
      <h6 class="card-title main-title">{{product.title}}</h6>
      <small class="text-muted smaller">Dimensão: {{product.dimension}}</small>
      <h6 class="indicated-title">Indicado:</h6>
      <small class="text-muted indicated smaller">{{product.indicated_to}}</small>
    </div>

    <div class="description">
      <template v-if="product.promotional_price">
        <p class="promotional">
          <small>R$ {{product.price}}</small>
        </p>
        <p>R$ {{product.promotional_price}}</p>
      </template>
      <template v-else>
        <p class="product-price">R$ {{product.price}}</p>
      </template>

      <star-rating
        v-if="product.rating"
        :star-size="20"
        :rating="product.rating"
        :show-rating="false"
        :read-only="true"
        :increment="0.5">
      </star-rating>
    </div>
  </div>


</template>

<script>
  export default {
    name: 'offer-content',

    props: {
      product: Object,
    },
  };
</script>

<style scoped>
  .indicated {
    white-space: pre-line;
  }

  .smaller {
    font-size: 75%;
  }

  .main-title {
    font-weight: 500;
    margin-bottom: 0;
  }

  .indicated-title {
    font-size: 75%;
    font-weight: 500;
    margin-bottom: 0;
  }

  .promotional {
    text-decoration: line-through;
    text-decoration-color: #ED1763;
    margin: 0;
    color: #777;
  }

  .product-price {
    color: #000000;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 0;
    font-family: Montserrat;
  }

  .offer-box {
    height: 100%;
  }

  .description{
    height: 60%;
    padding: 0;
  }
</style>


// WEBPACK FOOTER //
// resources/assets/js/store/components/OfferContent.vue